import { createFileRoute } from '@tanstack/react-router'
import { GerenciarRoles } from '@/features/gerenciar-roles'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/gerenciar-roles/')({
  beforeLoad: async () => {
    await requireAdmin()
  },
  component: GerenciarRoles,
})
